const VARIANT_ID = 47941820580076;

document.addEventListener("DOMContentLoaded", () => {
    const form = document.getElementById("bniForm");

    form.addEventListener("submit", async function (e) {
        e.preventDefault();

        // Disable button to prevent double clicks
        const submitBtn = document.getElementById('payBtn');
        submitBtn.disabled = true;
        submitBtn.innerText = "Processing...";

        const attended = document.querySelector('input[name="bni"]:checked').value;

        // 1. Prepare data for your PHP Backend
        const registrationData = {
            name: document.getElementById("name").value,
            business: document.getElementById("business").value,
            phone: document.getElementById("phone").value,
            email: document.getElementById("email").value,
            years: document.getElementById("years").value || 0,
            invited: document.getElementById("invited").value,
            attended: attended
        };

        try {
            // 2. Send Data to your PHP Database first
            // REPLACE THIS URL with your live hosting URL where you uploaded the API folder
            const dbResponse = await fetch("https://peru-bear-980652.hostingersite.com/api/save-registration.php", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(registrationData)
            });

            const dbResult = await dbResponse.json();

            if (dbResult.success) {
                // 3. Now add to Shopify Cart with the RegistrationID
                const data = {
                    items: [{
                        id: VARIANT_ID,
                        quantity: 1,
                        properties: {
                            "RegistrationID": dbResult.id, // This links the Shopify order to your DB
                            "Visitor Name": registrationData.name,
                            "Business": registrationData.business
                        }
                    }]
                };

                await fetch("/cart/clear.js", {
                    method: "POST"
                });

                await fetch("/cart/add.js", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                });

                // 4. Redirect to Checkout
                window.location = "/checkout";
            } else {
                alert("Error saving registration. Please try again.");
                submitBtn.disabled = false;
                submitBtn.innerText = "Pay ₹1000";
            }
        } catch (error) {
            console.error("Error:", error);
            alert("Connection error. Please ensure your PHP API is live and try again.");
            submitBtn.disabled = false;
            submitBtn.innerText = "Pay ₹1000";
        }
    });
});
